import React from "react";
import ScheduleRunContainer from "../../../containers/Fee/ScheduleRunContainer/ScheduleRunContainer";

const ScheduleRun = (props) => {
  return <ScheduleRunContainer {...props} />;
};

export default ScheduleRun;
